import { memo, useEffect, useRef } from 'react';

import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';

import {
  ScaffolderFieldError,
  ScaffolderFormPaper,
  ScaffolderInputHeader,
} from '../../../components';
import { APPSET_APP_NAME } from '../infoDoc';
import { useStyles } from '../styles';
import { validateAppSetTemplatePattern } from '../validation';

export interface ApplicationSetAppNameTemplateSectionProps {
  value: string;
  onChange: (value: string) => void;
  errors: string[];
}

const ApplicationSetAppNameTemplateSectionInner = ({
  value,
  onChange,
  errors,
}: ApplicationSetAppNameTemplateSectionProps) => {
  const { classes } = useStyles();
  const sectionRef = useRef<HTMLDivElement>(null);
  const appNameTemplateError =
    errors.length > 0 &&
    (!value || !value.trim() || !validateAppSetTemplatePattern(value))
      ? 'Application name template is required and must be a valid template expression.'
      : '';

  useEffect(() => {
    if (appNameTemplateError) {
      sectionRef.current?.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
    }
  }, [appNameTemplateError]);

  return (
    <div ref={sectionRef}>
      <ScaffolderFormPaper>
        <ScaffolderInputHeader
          title="Application"
          description="Application Name which will be used in the ApplicationSet."
          variant="h5"
          divider
        />
        <Box>
          <Box className={classes.inputContainer}>
            <ScaffolderInputHeader
              title="Templated Application Name"
              description="Specify the name of the application to be created."
              infoDoc={APPSET_APP_NAME}
            />
            <TextField
              label="Templated Application Name"
              variant="outlined"
              margin="none"
              size="small"
              fullWidth
              required
              value={value}
              onChange={e => onChange(e.target.value)}
              error={Boolean(appNameTemplateError)}
              helperText={
                appNameTemplateError ? (
                  <ScaffolderFieldError message={appNameTemplateError} />
                ) : (
                  ''
                )
              }
            />
          </Box>
        </Box>
      </ScaffolderFormPaper>
    </div>
  );
};

export const ApplicationSetAppNameTemplateSection = memo(
  ApplicationSetAppNameTemplateSectionInner,
);
